import Box from "@material-ui/core/Box";
import * as React from "react";
import { connect } from "react-redux";

import { Dispatch, StoreState } from "../../../store";
import {
  ElectricityFilter,
  GasFilter,
  GlassFiberFilter,
  HeatingFilter,
  ProductType,
  SupplyType,
  Tariff,
} from "../../../types/index";
import Autocomplete from "../../Autocomplete";
import { getTariffSelectOptionsFromTariffTypes } from "./utils";

function mapStateToProps({
  tariffTypesElectricity,
  tariffTypesGas,
  tariffTypesHeating,
  tariffTypesGlassFiber,
}: StoreState) {
  return {
    [ProductType.ELECTRICITY]: tariffTypesElectricity,
    [ProductType.GAS]: tariffTypesGas,
    [ProductType.HEATING]: tariffTypesHeating,
    [ProductType.GLASS_FIBER]: tariffTypesGlassFiber,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchTariffTypes: (productType: ProductType) => {
      switch (productType) {
        case ProductType.ELECTRICITY:
          dispatch.tariffTypesElectricity.fetchTariffTypesElectricity(null);
          break;
        case ProductType.GAS:
          dispatch.tariffTypesGas.fetchTariffTypesGas(null);
          break;
        case ProductType.HEATING:
          dispatch.tariffTypesHeating.fetchTariffTypesHeating(null);
          break;
        case ProductType.GLASS_FIBER:
          dispatch.tariffTypesGlassFiber.fetchTariffTypesGlassFiber(null);
      }
    },
  };
}

type Props = {
  productTypeFilter:
    | ElectricityFilter
    | GasFilter
    | HeatingFilter
    | GlassFiberFilter;
  onChange: (tariff: Tariff[]) => void;
  productType: ProductType;
  disabled?: boolean;
} & ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class CustomerProperties extends React.Component<Props> {
  public async componentDidMount() {
    this.props.fetchTariffTypes(this.props.productType);
  }

  public render(): JSX.Element {
    return (
      <Box marginTop={1}>
        <Autocomplete
          disabled={this.props.disabled}
          options={getTariffSelectOptionsFromTariffTypes(
            this.filterTariffsBySupplyType(
              this.filterTariffsByProductFamilies(
                this.props[this.props.productType].data,
                this.props.productTypeFilter.productFamilies
              )
            )
          )}
          onChange={this.handleTariffTypesChange()}
          value={getTariffSelectOptionsFromTariffTypes(
            this.props.productTypeFilter.tariffs
          )}
          label="Tariftyp"
          placeholder="Bitte auswählen..."
        />
      </Box>
    );
  }

  private filterTariffsBySupplyType = (tariffs: Tariff[]): Tariff[] => {
    let supplyType: SupplyType | null = null;
    if (
      this.props.productType === ProductType.ELECTRICITY ||
      this.props.productType === ProductType.GAS
    ) {
      supplyType = (this.props.productTypeFilter as
        | ElectricityFilter
        | GasFilter).supplyTypeFilter;
    }
    return tariffs.filter((tariff) => {
      if (supplyType) {
        return tariff.supplyType === supplyType;
      } else {
        return true;
      }
    });
  };

  private filterTariffsByProductFamilies = (
    tariffs: Tariff[],
    productFamilies: string[]
  ): Tariff[] => {
    return tariffs.filter((tariff) => {
      if (productFamilies.length) {
        return productFamilies.includes(tariff.productFamily);
      } else {
        return true;
      }
    });
  };

  private handleTariffTypesChange = () => (
    tariffTypeOptionsSelected: Array<{ label: string; value: Tariff }>
  ) => {
    this.props.onChange(
      tariffTypeOptionsSelected.map((option) => option.value)
    );
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerProperties);



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/CustomerTariffsFilter.tsx